import { defineComponent as d, computed as l, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as n, createCommentVNode as h, normalizeStyle as f, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "b61d84b6-41cc-4657-b088-39a2bd378bc7" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#b61d84b6-41cc-4657-b088-39a2bd378bc7)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#0052b4" d="M0 0h512v89l-61.2 165.6L512 423v89H0v-89l62.5-174.6L0 89z"></path><path fill="#eee" d="M0 89h512v33.4l-28.1 130L512 389.7V423H0v-33.4L30 255 0 122.4z"></path><path fill="#d80027" d="M0 122.4h512v267.2H0z"></path><circle cx="157.5" cy="256" r="98.5" fill="#eee"></circle><path fill="#d80027" d="m157.5 157.5 22.1 68h71.6l-58 42 22.3 68.3-58-42.3-58 42.2 22.2-68.1-57.9-42h71.6z"></path>', 5), g = { fill: "none" }, b = ["r"], z = /* @__PURE__ */ d({
  __name: "kp",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, o = l(() => 512 + 2 * e.strokeWidth), c = l(() => -e.strokeWidth), a = l(() => 256 + e.strokeWidth / 2);
    return (x, w) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${o.value} ${o.value}`
    }, [
      m,
      t("g", v, [
        e.flagName ? (s(), i("title", k, n(e.flagName), 1)) : h("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, _));
  }
});
export {
  z as default
};
//# sourceMappingURL=kp-1c5a10fe.js.map
